var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.385 3.73779C8.78125 3.73779 5.98 3.73779 4.23875 5.47779C2.5 7.21779 2.5 10.019 2.5 15.6203C2.5 21.2215 2.5 24.0228 4.24 25.7628C5.98125 27.5028 8.7825 27.5028 14.3862 27.5028C19.99 27.5028 22.7912 27.5028 24.5325 25.7628C26.2725 24.0228 26.2725 21.2215 26.2725 15.6203V14.9953",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 26.2376C11.5125 20.2976 17.425 12.4213 26.25 18.3288M22.4962 2.49756V12.5076M27.5012 7.47131L17.4887 7.49006",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFiles);
export default __webpack_public_path__ + "static/media/upload_files.17e05e4d6400968cd65736b276c00b5f.svg";
export { ForwardRef as ReactComponent };